module.exports = __webpack_public_path__ + "img/BulkSigning.50d885e6.svg";